module.exports = __webpack_public_path__ + "media/honey-icons/icon-night-vision-f08a2b64.svg";